import { useState } from 'react'
import { View, Text } from 'react-native'
import { translate } from '../../../../../i18n'
import { styles } from './InformationGameOverStyle'
import ChipsIcon from '../../../../ANewDesign/assets/Chips.svg'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../../models'

export const InformationGameOver = observer(() => {
  const {
    game: { leaderboardData }
  } = useStore()

  const [handWinnerInfo] = useState(leaderboardData)

  if (!handWinnerInfo) return null

  const { runTime, winners } = handWinnerInfo
  const prizePool = winners[0].chipsWon

  return (
    <View style={styles.informationGame}>
      <View style={styles.information}>
        <Text style={styles.informationTitle}>{translate('informationGameOver.runtime')}</Text>
        <View style={styles.informationWithOutIcon}>
          <Text style={styles.informationText}>{runTime}</Text>
        </View>
      </View>
      <View style={styles.information}>
        <Text style={styles.informationTitle}>{translate('informationGameOver.prizePool')}</Text>
        <View style={styles.informationIconText}>
          <ChipsIcon />
          <Text style={styles.informationText}>{prizePool}</Text>
        </View>
      </View>
    </View>
  )
})
